<mat-radio-group class="catalogSort__formRadio">
  <mat-radio-button
    *ngFor="let item of indices"
    name="catalogSort"
    class="formRadio__input"
    [value]="item.name"
    [checked]="state.currentRefinement === item.name"
    (click)="$event.preventDefault(); updateSelected(item)"
    (keydown)="checkActivationButtonKeyService($event, item)"
  >
    <ng-container [ngSwitch]="item.name">
      <ng-container *ngSwitchCase="'ng-products-master'" i18n="@@CATALOG.SORT.RELEVANCE">{{ item.label }}</ng-container>
      <ng-container *ngSwitchCase="'ng-products-slave-us'" i18n="@@CATALOG.SORT.RELEVANCE">{{
        item.label
      }}</ng-container>
      <ng-container *ngSwitchCase="'ng-products-slave-price-asc'" i18n="@@CATALOG.SORT.PRICE_ASC">{{
        item.label
      }}</ng-container>
      <ng-container *ngSwitchCase="'ng-products-slave-price-desc'" i18n="@@CATALOG.SORT.PRICE_DESC">{{
        item.label
      }}</ng-container>
      <ng-container *ngSwitchCase="'ng-products-slave-recent'" i18n="@@CATALOG.SORT.MOST_RECENT">{{
        item.label
      }}</ng-container>
    </ng-container>
  </mat-radio-button>
</mat-radio-group>
